import { useContext } from "react";

import { AuthContext } from "../contexts/authContext";

export default function useMfa() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useMfa must be used within an AuthProvider");
  }
  return {
    validateMfa: context.validateMfa,
    sendMfaCode: context.sendMfaCode,
    mfaState: context.mfaState,
  };
}
